'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListViewButton = function ListViewButton(_ref) {
  var currentView = _ref.currentView,
      toggleListView = _ref.toggleListView,
      className = _ref.className;

  var isActive = currentView === 'small' ? 'active' : '';
  var toggleView = function toggleView() {
    return toggleListView('small');
  };

  var btnClasses = (0, _classnames2.default)(className, { active: currentView === 'small' });

  return _react2.default.createElement(
    _reactIntl.FormattedMessage,
    { id: 'list_view', values: { isActive: isActive ? 'yes' : 'no' } },
    function (message) {
      return _react2.default.createElement(
        _baseButtons.DefaultButton,
        { 'data-test-id': 'list-view-button', flat: true, className: btnClasses, handleClick: toggleView, title: message },
        _react2.default.createElement(_baseIcons.ListView, null),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          message
        )
      );
    }
  );
};

ListViewButton.propTypes = {
  className: _react.PropTypes.string,
  currentView: _react.PropTypes.string.isRequired,
  toggleListView: _react.PropTypes.func.isRequired
};

exports.default = ListViewButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-list-view-button/lib/components/ListViewButton.component.js
// module id = 1330
// module chunks = 1